import { useState, useEffect } from 'react';

import style from './index.module.scss';
import { useSelector } from 'react-redux';

export default function MenuBtnStickyMobile({ menuState, currentMenuState }) {
	const { isOnline } = useSelector((state) => state.user);

	const toggleState = () => {
		menuState(!currentMenuState);
	};

	useEffect(() => {
		const handleResize = () => {
			if (document.body.clientWidth > 768 && currentMenuState) {
				menuState(false);
			}
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, [currentMenuState, menuState]);

	if (!isOnline) return null;

	return (
		<button
			className={`hamburger ${style.wrapper} ${style.sticky} ${currentMenuState && style.isClicked}`}
			onClick={toggleState}
		>
			<div className={`hamburger__bun ${style.bun}`}>
				<div className={`hamburger__burger ${style.burger}`}></div>
			</div>
			<span className="is-sr-only">Toggle mobile menu</span>
			<div className={style.MenuAction}>
				<span className={style.menu}>Menu</span>
				<span className={style.close}>Close</span>
			</div>
		</button>
	);
}
